import React from 'react';
import { Row,Col } from 'antd';
import BaseComponent from '../../../components/BaseComponent';
import ImageGrid from '../../../components/ImageGrid';
import AdPrice from '../components/AdPrice';
import Schedule from '../components/Schedule';
import {isMobile} from 'react-device-detect';
//import nl2br from 'react-nl2br';

class TemplateTravel01 extends BaseComponent {
  constructor(props) {
    super(props);
  }
/*
  componentWillMount() {
  }
*/
  render() {
    const {data} = this.props;

    return (
      <div id="template-01">
        <div className="ad-travel is-alpha">
          <Row gutter={16}>
            <Col xs={6}>
              <div className="ad-travel__recommend mb-1">
                トラトラのおすすめツアー
              </div>
              <div className="ad-travel__title">
                <a className="blog-ad-travel__title" href={data.url}>
                  {/* nl2br(data.name) */}
                  {data.name}
                </a>
              </div>
              <div className="ad-travel__desc">
                {data.intro}
              </div>
              <AdPrice {...data} />

              {!isMobile &&
              <a href={data.url} className="btn btn-success btn-block mb-3 blog-ad-travel__viewdetail">ツアーの詳細をみる</a>
              }

              <Schedule {...data} />
            </Col>
            <Col xs={6}>
              {data.thumb &&
              <a className="blog-ad-travel__mainphoto" href={data.url}>
                <img src={data.thumb} alt={data.name}/>
              </a>
              }
              <ImageGrid images={data.images} gallery={data.source} opt={{itemClass: 'blog-ad-travel__photogallery mb-2'}}/>

              {isMobile &&
              <a href={data.url} className="btn btn-success btn-block mb-3 blog-ad-travel__viewdetail">ツアーの詳細をみる</a>
              }
            </Col>
          </Row>
        </div>
      </div>
    )
  }
};

export default TemplateTravel01;
/*
export default connect(({ meta }) => ({
  meta
}))(TemplateTravel01);
*/



// WEBPACK FOOTER //
// ./src/pages/ad/templates/TemplateTravel01.js